import { CHECK_BOX_VALUE, ERP_SALES_ORDER, GRID_ROWS_PER_PAGE, NAVIGATE_PATH } from '../../../constants';
 
export const initialState = {
  orderTypes: [],
  searchResult: [],
  searchLoading: false,
  orderNumberFrom: '',
  orderNumberTo: '',
  importType: ERP_SALES_ORDER.YES_VALUE,
  orderType: ERP_SALES_ORDER.ANY_VALUE,
  orderNumberSearch: '',
  searchType: ERP_SALES_ORDER.search.ORDER_NUMBER,
  manualPurchaseOrder: {
    orderId: 0,
    orderNumber: '',
    firstModifiedTimestamp: new Date(),
    psPrefixCode: 'MPO',
    psCustomerCode: '',
    customerName: '',
    psSiteCode: '',
    siteName: '',
    description: '',
    customerId: 0,
    siteId: 0,
    firstModifiedUserId: 0,
  },
  addLineItemClicked: false,
  createdMPOSuccessfully: false,
  erpStagingSearchData: null,
  erpFastSearchData: null,
  erpFastSearchItemsData: null,
  selectedOrder: null,
  displayType: ERP_SALES_ORDER.DISPLAY_TYPE.CREATE_UPDATE,
  entitlmentSummaryData: [],
  entitlementSummaryTotal: 0,
  rowsPerPage: GRID_ROWS_PER_PAGE.erpSalesOrderSummary,
  isAddItemLine: false,
  loading: false,
  isOrderItemDataFound: false,
  salesOrderItemsTotal: 0,
  salesOrderItems: [],
  isSalesProductModal: false,
  editsalesProductId: '',
  editsalesProductCode: '',
  salesProductName: '',
  salesProductNameFound: false,
  salesProduct: {
    productCodeContains: null,
    nameContains: '',
  },
  searchProductData: [],
  isSearchProductResults: false,
  searchProductotalRecord: 0,
  selectedSalesProductData: null,
  saveOrderLineItem: null,
  updateErpLineItem: null,
  deleteErpLineItem: null,
  orderlineNumber: 0,
  startOrderLineNumber: 1,
  erpLineItem: {
    shipQuantity: '',
  },
  saveLineItems: false,
  selectedErpLineItemGridData: null,
  isErpLineUpdate: false,
  salesProductId: '',
  isDisabledButtons: false,
  salesProductValue: '',
  erpLineItemPrice: {
    unitPrice: '0.00',
    salesPrice: '0.00',
    unsupportedFlag: CHECK_BOX_VALUE.no,
  },
  isDeleteLineItem: false,
  issaveLineItem: true,
  isUpdateLineItem: false,
  alertDialog: false,
  isLineNumbarClick: false,
  isProductCodeClick: false,
  iserpSalesOrderItemsFastSearchData: false,
  erpSalesOrderItemsFastSearchData: [],
  backUrl: NAVIGATE_PATH.home,
  doNotResetFlag: false,
  shipDate: null,
  oldshipDate: null,
  newshipDate: null,
};